export const paymentItemMock = {
  id: 494391,
  returnId: 82318,
  itemFromPastTwoWeeks: "1",
  openCheck: "0",
  amountLeftToDeposit: 0,
  finalPrice: 150,
  refundedPrice: 150,
  time_stamp: "2022-08-15 10:09:30",
  paymentType: 3,
  statusName: "REFUND_APPROVED",
  returnAmount: 150,
  returnFromPastTwoWeeks: "1",
  returnHandled: "1",
  returnNotHandled: "0",
  refundType: "CREDIT",
  depositNumber: null,
  cardName: null,
  cardBrand: null,
  cardNum: null,
  cardExp: "0627",
  paymentDate: "2022-08-15 13:06:00",
  email: "Sirdeguya@gmail.com",
  personalId: "305246134",
  receiptNum: "444053",
  receiptUrl:
    "https://app.icount.co.il/hash/p_print.php?code=MGwrS3VKcldlQlVkT3d3QU9jcjN4cU9uTmUrQzhwejNXUW1KdWM3ejVLQT0%3D",
  city: "כחל",
  street: "הכחלי 5",
  house: null,
  payerFirstName: "הורה",
  payerLastName: "כחול",
  authNumber: "1702326",
  childPersonalId: "890108566",
  childLastName: "כחול",
  childFirstName: "טובה",
  eventDate: "2022-06-17 08:00:00",
  nestName: "אאא",
  eventName: "אירוע ראשון לבדיקה",
  code: "1234003",
  layer: 'י"ב',
  layerId: 12,
  userFirstName: "גיא ",
  userLastName: "לוין",
  receiptIssuer: "גיא  לוין",
  parentFirstName: "גיא ",
  parentLastName: "לוין הורה",
  isCollapsed: false,
  itemDetails: {
    eventQuestions: {
      questions: [
        {
          questionId: 161180,
          questionText:
            "מה שם הקבוצה של החניכ/ה? אם אינך יודע את שם הקבוצה נא לכתוב את שם בית הספר והכיתה בה הוא לומד.",
          answers: [],
        },
        {
          questionId: 161181,
          questionText: "האם החניך/ה צמחוני/ת, בשרי/ת או טבעוני/ת?  פרט/י",
          answers: [],
        },
        {
          questionId: 161182,
          questionText:
            "הנני לאשר שלבני/בתי אין הגבלות בריאותיות ואינו רגיש לחומרים מסויימים. אנא פרט/י אם כן",
          answers: [],
        },
        {
          questionId: 161183,
          questionText: "האם לחניך/ה יש מגבלות אכילה הדורשות טיפול מיוחד?",
          answers: [],
        },
        {
          questionId: 161184,
          questionText:
            "הנני לאשר כי כל הפרטים שמסרתי נכונים, על החתום (שם ההורה בלבד)",
          answers: [],
        },
        {
          questionId: 161185,
          questionText:
            'אישור הורים להשתתפות בפעילות\nהנני לאשר לבני/בתי להשתתף בפעילות הנוע"ל שאליה נרשם/ה',
          answers: [],
        },
      ],
      submittedQuestions: {
        "מה שם הקבוצה של החניכ/ה? אם אינך יודע את שם הקבוצה נא לכתוב את שם בית הספר והכיתה בה הוא לומד.":
          "יךלח",
        "האם החניך/ה צמחוני/ת, בשרי/ת או טבעוני/ת?  פרט/י": "יךל",
        "הנני לאשר שלבני/בתי אין הגבלות בריאותיות ואינו רגיש לחומרים מסויימים. אנא פרט/י אם כן":
          "ךלחי",
        "האם לחניך/ה יש מגבלות אכילה הדורשות טיפול מיוחד?": "חי",
        "הנני לאשר כי כל הפרטים שמסרתי נכונים, על החתום (שם ההורה בלבד)": "ךלח",
        'אישור הורים להשתתפות בפעילות\nהנני לאשר לבני/בתי להשתתף בפעילות הנוע"ל שאליה נרשם/ה':
          "לחילךח",
      },
    },
    returnTable: [
      {
        timeAndDate: "2022-08-15 13:06",
        userName: "הורה לבדיקה בדיקה",
        comment: "בדיקת החזר מסוף אמת חדש",
        note: {
          isDocument: true,
          documents: [],
        },
        amount: null,
        status: "REFUND_REQUESTED",
      },
      {
        timeAndDate: "2022-08-15 13:09",
        userName: "גיא  לוין",
        comment: "מאשר החזר - מסוף ישן",
        amount: 150,
        status: "REFUND_APPROVED",
      },
    ],
  },
  address: " כחל הכחלי 5",
  parentFullName: " גיא  לוין הורה",
  userFullName: " גיא  לוין",
  childFullName: " טובה כחול",
  payerFullName: " הורה כחול",
  refundHoursDiffrence: -1421.1,
  refundTypes: ["CREDIT", "TRANSFER"],
};



// WEBPACK FOOTER //
// ./src/tests/mocks/payment-item.mock.ts